module.exports = __webpack_public_path__ + "static/media/jeverson.f488d41b.jpg";